<style lang="scss" scoped>
.classes {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
			> div {
				margin-right: 15px;
				font-size: 100%;
			}
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	.toggleButton {
		margin-right: 10px;
	}
	&__table {
		border-collapse: collapse;
		td,
		th {
			&:first-child {
				padding-left: 40px !important;
			}
			&:last-child {
				padding-right: 40px;
			}
		}
		td.-item {
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
		tr.hover:hover {
			background-color: #D6D6D6;
			cursor: pointer;
		}
	}
}
</style>
<template lang="pug">
.classes
	app-header
		.classes__header(slot='header')
			h1 {{activeClass.name}} {{ activeClass.code ? `(${activeClass.code})` : ''}} Instructors
			.classes__header__options
				el-dropdown(@command="multiSelectCommand").ml-auto
					el-button(type="primary", :disabled="inputClassMembers.length < 1", :loading="saveLoading") {{ actionText }} {{ inputClassMembers.length > 0 ? inputClassMembers.length : '' }} selected
						i(class="el-icon-arrow-down el-icon--right")
					el-dropdown-menu(slot="dropdown")
						el-dropdown-item(command="add", v-if="inputClassMembers.length > 0") Add user{{ inputClassMembers.length > 1 ? 's' : '' }} as instructor{{ inputClassMembers.length > 1 ? 's' : '' }}
						el-dropdown-item(command="remove", v-if="inputClassMembers.length > 0") Remove user{{ inputClassMembers.length > 1 ? 's' : '' }} as instructor{{ inputClassMembers.length > 1 ? 's' : '' }}
	.classes__container
		.classes__panel
			result-filter.ml-auto.mr-2(v-model='filters', :filter-fields='fields', :remember="false")
			loading(v-if="$apollo.loading || saveLoading")
			template(v-else)
				table.table.classes__table
					thead
						tr
							th(width="80")
								input(v-model='checkAll', type='checkbox')
							th First name
							th Last name
							th Instructor?
					tbody
						tr.hover(v-for='(row, index) in paginated', :key='index', @click="rowClicked(row)")
							td
								input(v-model='row.selected', type='checkbox')
							td {{ row.first_name }}
							td {{ row.last_name }}
							td {{ row.role === "Instructor" ? "Yes": "No" }}
				.classes__footer
					.classes__footer__left
						el-pagination(background='', layout='prev, pager, next', :current-page.sync='page', :page-size='per_page', :total='filtered.length')
					.classes__footer__right(v-if="0 && filtered")
						| Showing
						strong &nbsp;{{ paginated.length }}
						| &nbsp;out of a possible
						strong &nbsp;{{ filtered.length }}
						| &nbsp;results
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import Fuse from "fuse.js";
import Bugsnag from "@bugsnag/js";
export default {
	watch: {
		checkAll(val) {
			_.each(this.filtered, r => {
				this.$set(r, "selected", val)
			});
		}
	},
	data() {
		return {
			filters: null,
			saveLoading: false,
			page: 1,
			per_page: 50,
			directoryLoading: true,
			checkAll: false,
			fields: [
				{
					name: "First name",
					path: "first_name",
					type: "text"
				},
				{
					name: "Last name",
					path: "last_name",
					type: "text"
				},
				{
					name: "Role",
					path: "role",
					type: "radio",
					options: [
						{
							label: "Instructors only",
							value: "instuctor"
						},
						{
							label: "All staff",
							value: "all"
						},
					],
				},
			],
			instructorIds: [],
			filters: null,
		};
	},
	computed: {
		saveButtonType() {
			return "primary";
		},

		actionText() {
			return this.saveLoading ? "Actioning" : "Action";
		},

		selected() {
			return _.filter(this.filtered, { selected: true });
		},

		inputClassMembers() {
			return _(this.filtered)
				.filter((user) => {
					return user.selected;
				})
				.map((user) => {
					return {
						wondeId: this.activeClass.id,
						wondeIdType: this.activeClass.type,
						memberId: user.id,
						memberIdType: "employee"
					};
				})
				.value();
		},

		filtered() {
			let filtered = _(this.users)
				.filter((user) => {
					return user.base_type == "employee";
				})
				.map((user) => {
					user.role = this.instructorIds.includes(user.id) ? "Instructor": null;
					return user;
				})
				.value();

			if (this.users && this.filters) {
				if (this.filters.first_name) {
					filtered = _.filter(filtered, row => {
						return this.filters.first_name.filter_type == 'starts_with' ? _.startsWith(row.first_name.toLowerCase(), this.filters.first_name.value.toLowerCase()) : row.first_name.toLowerCase().includes(this.filters.first_name.value.toLowerCase());
					});
				}
				if (this.filters.last_name) {
					filtered = _.filter(filtered, row => {
						return this.filters.last_name.filter_type == 'starts_with' ? _.startsWith(row.last_name.toLowerCase(), this.filters.last_name.value.toLowerCase()) : row.last_name.toLowerCase().includes(this.filters.last_name.value.toLowerCase());
					});
				}
				if (this.filters.role && this.filters.role.value !== "all") {
					filtered = _.filter(filtered, row => {
						return this.instructorIds.includes(row.id);
					});
				}
			}
			return filtered;
		},

		paginated() {
			return _.chunk(this.filtered, this.per_page)[this.page - 1];
		},

        activeClass() {
			if (!_.isEmpty(this.classes)) {
				const cls = _.first(this.classes.filter((cls) => {
					return cls.id == this.$route.params.id;
				}));
				this.instructorIds = _.map(cls.Teachers, (teacher) => teacher.id);

				return cls;
			}
            
			return null;
        },
	},
	methods: {
		async saveMatches(inputClassMembers) {
			this.saveLoading = true;
			try {
				await this.$apollo.mutate({
					mutation: gql`
						mutation ClassMembersOverride($classMembersOverride: [ClassMembersOverrideInput!]!) {
							ClassMembersOverride(classMembersOverride: $classMembersOverride) {
								wondeId
								wondeIdType
								memberId
							}
						}
					`,
					variables: {
						classMembersOverride: inputClassMembers
					}
				});
			} catch (error) {
				Bugsnag.notify(JSON.stringify(error, null, 2));
				this.$message.error("Failed to update instructors");
			}
		},

		async saveByBatch(val) {
			this.saveLoading = true;
			// Archiving more than 6 classes is timing out for some schools
			const perPage = 6;
			let curPage = 1;
			let promises = [];
			let chunk = _.chunk(this.inputClassMembers, perPage)[curPage - 1];
			
			while(chunk) {
				chunk = _.map(chunk, (cls) => {
					cls.action = val;

					return cls;
				});
				
				promises.push(this.saveMatches(chunk));
				curPage++;
				chunk = _.chunk(this.inputClassMembers, perPage)[curPage - 1];
			}

			await Promise.all(promises);
			await this.$apollo.queries.classes.refetch();
			this.$message.success(`Class instructors have been successfully updated`);
			this.checkAll = false;
			this.saveLoading = false;
		},

		async multiSelectCommand(action) {
			await this.saveByBatch(action)
		},

		rowClicked(row) {
			this.$router.push({ name: "instructor.classes", params: {id: row.id}})
		},
	},

	apollo: {
		users: {
			query: gql`
				{
					Directory {
						id
						WondeUsers {
							id
							first_name
							last_name
							base_type
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r => r.Directory.WondeUsers,
			result() {
				this.directoryLoading = false;
			}
		},
		classes: {
			query: gql`
				{
					Classes {
						id
						name
						type
                        code
						Teachers {
							id
						}
					}
				}
			`,
			fetchPolicy: "cache-and-network",
			update: r =>
				_(r.Classes)
                    .map(cls => ({
						...cls
					}))
					.sortBy("name")
					.value()
		},
	}
};
</script>
